import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Col, Form, Icon, Modal, Popconfirm, Row, Select, Table } from 'antd';
import moment from 'moment';
import _ from 'lodash';

import * as leadController from '../../../../../../services/api/lead';
import * as consultantController from '../../../../../../services/api/consultant';
import ProgrammeInfoBtn from '../../../../../../components/ProgrammeInfoBtn/ProgrammeInfoBtn';
import CustomerInfoBtn from '../../../../../../components/CustomerInfoBtn/CustomerInfoBtn';
import ConsultantInfoBtn from '../../../../../../components/ConsultantInfoBtn/ConsultantInfoBtn';
import './LeadList.scss';

const TABLE_PAGESIZE = process.env.TABLE_PAGESIZE;

const FormItem = Form.Item;
const Option = Select.Option;

export class LeadList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dataSource: [],
            selectedRowKeys: [],
            showAllLead: false,
            consultants: [],
            assignModalVisible: false,
            assignTarget: undefined,
            pagination: {
                pageSize: parseInt(TABLE_PAGESIZE, 10)
            },
            sorter: {},
            filters: {},
            searchText: undefined,
            isLoading: false
        }
    }

    filterData() {
        const { filters, searchText } = this.props;
        const { pagination } = this.state;

        this.setState({ pagination: { ...pagination, current: 1 }, filters, searchText });
    }

    fetchConsultants() {
        consultantController.getConsultants({ isSimple: true })
            .then((res) => res.json())
            .then((json) => this.setState({ consultants: json }))
    }

    handleMerge() {
        const { selectedRowKeys, assignTarget } = this.state;

        this.setState({ isLoading: true });

        leadController.assignLeadsToConsultant(selectedRowKeys, assignTarget)
            .then((res) => res.json())
            .then((json) => {
                this.fetchData();
                this.setState({ assignModalVisible: false, assignTarget: undefined })
            })
            .catch((err) => console.log(err))
    }

    handleRemove() {
        const { selectedRowKeys } = this.state;

        this.setState({ isLoading: true });

        leadController.deleteLeads(selectedRowKeys)
            .then((res) => res.json())
            .then((json) => {
                this.fetchData();
            })
            .catch((err) => console.log(err))
    }

    handleTableChange(pagination, tableFilters, sorter) {
        this.setState({
            pagination,
            sorter
        });
    }

    fetchData() {
        const { userId } = this.props;
        const { pagination, sorter, filters, searchText, showAllLead } = this.state;
        let query = {
            limit: pagination.pageSize,
            page: pagination.current,
            sort_field: sorter.field,
            sort_order: sorter.order,
            search: searchText,
            ...filters,
        };

        if (!showAllLead)
            query.consultant_id = userId;

        this.setState({ isLoading: true });

        leadController.getLeads(query)
            .then((res) => res.json())
            .then((json) => {
                const dataSource = _.map(json.result, (record) => ({ ...record,
                    interested_programme: record.interested_programme ? record.interested_programme.name : '',
                    channel: record.channel ? record.channel.name : '',
                    customer: record.customer ? record.customer.name : '',
                    customer_email: record.customer ? record.customer.email : '',
                    customer_contact_number: record.customer ? record.customer.contact_number : '',
                    customer_email2: record.customer ? record.customer.email2 : '',
                    customer_contact_number2: record.customer ? record.customer.contact_number2 : '',
                    isCustomerLocked: record.customer ? record.customer.is_locked : false,
                    consultant: record.consultant ? record.consultant.name : ''
                }))
                this.setState({ dataSource, pagination: { ...this.state.pagination, total: json.count }, isLoading: false })
            })
            .catch((err) => console.log(err))
    }

    componentDidMount() {
        this.fetchData({ limit: TABLE_PAGESIZE, page: 1 });
        this.fetchConsultants();
    }

    componentDidUpdate(prevProps, prevState) {
        const { showAllLead, pagination, sorter, filters, searchText } = this.state;

        if (!_.isEqual(this.props.filters, prevProps.filters) || this.props.searchText !== prevProps.searchText) {
            this.filterData();
        }

        if (!_.isEqual(filters, prevState.filters) || searchText !== prevState.searchText || showAllLead !== prevState.showAllLead || !_.isEqual(pagination, prevState.pagination) || !_.isEqual(sorter, prevState.sorter)) {
            this.fetchData();
        }
    }

    renderExpandedTable(record) {
        const { customer_email, customer_contact_number, channel, consultant_id, consultant, message, enquiry_date, due_date, last_follow_up_date, next_follow_up_date, last_appointment_date, next_appointment_date, is_enrolled, enrolled_date, remarks, is_potential, is_blacklisted } = record;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };

        return (
            <Form className="ExpandedTableForm">
                <Row gutter={32}>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Customer Email">
                            <span>{customer_email}</span>
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Customer Contact Number">
                            <span>{customer_contact_number}</span>
                        </FormItem>
                    </Col>
                </Row>
                <Row gutter={32}>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Channel">
                            <span>{channel}</span>
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Consultant">
                            <span>{consultant}<ConsultantInfoBtn consultantId={consultant_id}/></span>
                        </FormItem>
                    </Col>
                </Row>
                <Row gutter={32}>
                    <Col span={24}>
                        <FormItem
                            labelCol={{ xs: { span: 24 }, sm: { span: 4 } }}
                            wrapperCol={{ xs: { span: 24 }, sm: { span: 20 } }}
                            label="Message"
                        >
                            <span className="text-with-newline">{message}</span>
                        </FormItem>
                    </Col>
                </Row>
                <Row gutter={32}>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Enquiry Date">
                            <span>{enquiry_date ? moment(enquiry_date).format('YYYY-MM-DD') : '--'}</span>
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Due Date">
                            <span>{due_date ? moment(due_date).format('YYYY-MM-DD') : '--'}</span>
                        </FormItem>
                    </Col>
                </Row>
                <Row gutter={32}>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Last Follow Up">
                            <span>{last_follow_up_date ? moment(last_follow_up_date).format('YYYY-MM-DD') : '--'}</span>
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Next Follow Up">
                            <span>{next_follow_up_date ? moment(next_follow_up_date).format('YYYY-MM-DD') : '--'}</span>
                        </FormItem>
                    </Col>
                </Row>
                <Row gutter={32}>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Last Appointment">
                            <span>{last_appointment_date ? moment(last_appointment_date).format('YYYY-MM-DD') : '--'}</span>
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Next Appointment">
                            <span>{next_appointment_date ? moment(next_appointment_date).format('YYYY-MM-DD') : '--'}</span>
                        </FormItem>
                    </Col>
                </Row>
                <Row gutter={32}>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Enrolled">
                            <span>{is_enrolled ? 'Yes' : 'No'}</span>
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Enrolled Date">
                            <span>{enrolled_date ? moment(enrolled_date).format('YYYY-MM-DD') : '--'}</span>
                        </FormItem>
                    </Col>
                </Row>
                <Row gutter={32}>
                    <Col span={24}>
                        <FormItem 
                            labelCol={{ xs: { span: 24 }, sm: { span: 4 } }}
                            wrapperCol={{ xs: { span: 24 }, sm: { span: 20 } }}
                            label="Remarks"
                        >
                            <span className="text-with-newline">{remarks}</span>
                        </FormItem>
                    </Col>
                </Row>
                <Row gutter={32}>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Potential">
                            <span>{is_potential ? 'Yes' : 'No'}</span>
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Blacklisted">
                            <span>{is_blacklisted ? 'Yes' : 'No'}</span>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        );
    }

    render() {
        const { userId, isAdmin, history } = this.props;
        const { dataSource, selectedRowKeys, showAllLead, consultants, assignModalVisible, assignTarget, pagination, isLoading } = this.state;
        const isRowSelected = selectedRowKeys.length !== 0;
        const consultantOptionComponents = _.map(consultants, (consultant) => <Option key={consultant.id} value={consultant.id}>{`${consultant.name} (${consultant.email || "N/A"})`}</Option>);

        const columns = [{
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
            sorter: true,
        }, {
            title: 'Source',
            dataIndex: 'source',
            key: 'source',
            align: 'center',
            sorter: true,
        }, {
            title: 'Customer',
            dataIndex: 'customer',
            key: 'customer',
            render: (text, record) => <span className={record.isCustomerLocked ? 'locked' : ''}>{text}<CustomerInfoBtn customerId={record.customer_id}/></span>,
            sorter: true,
        }, {
            title: 'Programme',
            dataIndex: 'interested_programme',
            key: 'interested_programme',
            render: (text, record) => text ? <span>{text}<ProgrammeInfoBtn programmeId={record.interested_programme_id}/></span> : '',
            sorter: true,
        }, {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            sorter: true,
        }, {
            title: 'Next Follow Up',
            dataIndex: 'next_follow_up_date',
            key: 'next_follow_up_date',
            align: 'center',
            render: (text) => text ? moment(text).format('YYYY-MM-DD') : '--',
            sorter: true,
        }, {
            title: 'Enrolled?',
            dataIndex: 'is_enrolled',
            key: 'is_enrolled',
            align: 'center',
            render: (text) => text ? <Icon type="check" /> : <Icon type="close" />,
            sorter: true,
        }, {
            title: '',
            dataIndex: 'edit',
            key: 'edit',
            align: 'center',
            render: (text, record) => ((record.consultant_id === userId) || isAdmin) ? (<Icon className="icon-btn" type="edit" onClick={() => history.push(`/dashboard/lead/${record.id}`)} />) : ''
        }];

        return (
            <div className="LeadList DataList">
                <div className="table-btn-gp">
                    <div className="table-btn-gp-left">
                        <button onClick={(e) => this.setState({ showAllLead: !showAllLead })}>
                            <Icon type={ showAllLead ? 'team' : 'user'}/>
                            { showAllLead ? 'All Lead' : 'My Lead'}
                        </button>
                    </div>
                    <div className="table-btn-gp-left">
                        <button onClick={(e) => history.push('/dashboard/lead/new')}>
                            <Icon type="plus"/>
                            Create
                        </button>
                        {
                            isAdmin &&
                            <button disabled={!isRowSelected} onClick={(e) => this.setState({ assignModalVisible: true })}>
                                <Icon type="solution" />
                                Assign
                            </button>
                        }
                    </div>
                    <div className="table-btn-gp-right">
                        {
                            isAdmin &&
                            <Popconfirm 
                                placement="bottom"
                                title="This action is irreversible, are you sure?" 
                                onConfirm={(e) => this.handleRemove()} 
                                okText="Yes" 
                                cancelText="No"
                            >
                                <button disabled={!isRowSelected}>
                                    <Icon type="minus"/>
                                    Remove
                                </button>
                            </Popconfirm>
                        }
                    </div>
                </div>
                <Table
                    loading={isLoading}
                    size="small"
                    rowKey="id"
                    columns={columns}
                    dataSource={dataSource}
                    rowSelection={{selectedRowKeys, onChange: (selectedRowKeys) => this.setState({selectedRowKeys})}}
                    rowClassName={(record, string) => (record.is_potential ? 'potential' : '')}
                    expandedRowRender={(record) => this.renderExpandedTable(record)}
                    pagination={pagination}
                    onChange={(pagination, filters, sorter) => this.handleTableChange(pagination, filters, sorter)}
                />
                <Modal
                    className="MergeModal"
                    visible={assignModalVisible}
                    footer={null}
                    onCancel={(e) => this.setState({ assignModalVisible: false, assignTarget: undefined })}
                >
                    <p>Select a consultant that you want to assign.</p>
                    <Select
                        dropdownMatchSelectWidth={false}
                        style={{ width: '100%' }}
                        value={assignTarget}
                        onSelect={(value) => this.setState({ assignTarget: value })}
                    >
                        {consultantOptionComponents}
                    </Select>
                    <Button type="primary" disabled={_.isUndefined(assignTarget)} onClick={(e) => this.handleMerge(e)}>Assign</Button>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    userId: state.user.id,
    isAdmin: state.user.isAdmin
})

export default connect(mapStateToProps)(withRouter(LeadList));


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/LeadPage/components/LeadList/LeadList.js